import { createTheme } from "@mui/material/styles";

const COLORS = {
    verdeClaro: "#acc90e",
    preto: "#000000",
    cinza: "#1e1e1e",
    branco: "#ffffff", // ou "#ffff" se você quiser manter, mas aqui prefiro padrão
};

const muiTheme = createTheme({
    palette: {
        mode: "dark",
        primary: { main: COLORS.verdeClaro },
        background: {
            default: COLORS.preto,
            paper: COLORS.cinza,
        },
        text: {
            primary: COLORS.branco,
            secondary: "rgba(255,255,255,0.72)",
        },
    },
    typography: {
        fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    },
    shape: { borderRadius: 16 },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: COLORS.verdeClaro,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: { backgroundImage: "none" },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    textTransform: "none",
                    fontWeight: 800,
                },
            },
        },
    },
});

export default muiTheme;
export { COLORS };